import type { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

import BaseTypography from 'src/legacy/components/Text/BaseTypography';

/**
 * @description This is deprecated. Please use the new TextCellRenderer component in src/components/table/TextCellRenderer.tsx
 * @deprecated use the new component in src/components/table/TextCellRenderer.tsx
 * @returns
 */
export const TextCellRenderer: React.FC<ICellRendererParams> = React.memo(
  (cellData) => (
    <BaseTypography>{cellData.valueFormatted || cellData.value}</BaseTypography>
  ),
);
